import React, { useState } from "react";
import { Modal, Typography, Box, Backdrop, Button, IconButton } from '@mui/material';
import { LoadingButton } from "@mui/lab";
import WarningIcon from '@mui/icons-material/Warning';


const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    bgcolor: 'background.paper',
    boxShadow: 24,
    outline: "none",
    borderRadius: "4px"
};

const ItemsSwitchWarning = ({ open, setOpen,setData, warningText, switchedTo, setItemEntry, items, itemsEdited, itemsTemp, nonItems, nonItemsEdited, nonItemsTemp,type }) => {

    const handleClose = (event, reason) => {
        if (reason !== 'backdropClick') {
            setOpen(false);
        }
    }

    function switchToTable() {
        if(switchedTo=='nonItems') {
            setItemEntry(false)
            setOpen(false);
            items([])
            itemsEdited({})
            itemsTemp({})
            if(type=="PURCHASE"){
            setData((prev)=>({
                ...prev,
                paidAmount:"",
            }))
        }else{
            setData((prev)=>({
                ...prev,
                receivedAmount:"",
            })) 
        }
        } else if (switchedTo=='items') {
            setItemEntry(true)
            setOpen(false);
            nonItems([])
            nonItemsEdited({})
            nonItemsTemp({})
            if(type=="PURCHASE"){
                setData((prev)=>({
                    ...prev,
                    paidAmount:"",
                }))
            }else{
                setData((prev)=>({
                    ...prev,
                    receivedAmount:"",
                })) 
            }
        }
    }


    return (

        <Modal
            aria-labelledby="transition-modal-title"
            aria-describedby="transition-modal-description"
            open={open}
            onClose={handleClose}
            closeAfterTransition
            BackdropComponent={Backdrop}
            BackdropProps={{
                timeout: 500,
            }}
        >
            {/* <Fade in={open}> */}
            <Box sx={style}>
                <Box sx={{
                    borderRadius: "4px",
                    backgroundColor: "white",
                    padding: "15px",
                    textAlign: "center",
                    overflowY: { xs: 'scroll', sm: 'hidden' },
                    '.MuiTableCell-root': {
                        padding: '10px 10px',
                        fontSize: '13px'
                    },
                }}>
                    <IconButton aria-label="delete" sx={{ marginBottom: '10px', backgroundColor: '#ffd55770' }}>
                        <WarningIcon sx={{ fontSize: '35px', color: '#ffc107' }} />
                    </IconButton>
                    <Typography fontWeight={400} textTransform='capitalize'>Warning</Typography>
                    <Typography sx={{ color: "#b28704", fontSize: '14px' }}>
                        {warningText}
                    </Typography>

                </Box>


                <Box sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    flexDirection: { xs: 'column', sm: 'row' },
                    paddingLeft: "15px",
                    paddingRight: "15px",
                    paddingBottom: "15px",
                }}>
                    <Button color="primary" onClick={handleClose} variant='outlined' sx={{ flex: 1, margin: '5px', fontSize: "12px" }} >Cancel</Button>
                    <Button color="primary" onClick={switchToTable} variant='contained' sx={{ flex: 1, margin: '5px', fontSize: "12px" }} >OK</Button>

                </Box>


            </Box>
            {/* </Fade> */}
        </Modal>

    );
};

export default ItemsSwitchWarning;